import apiClient from '@/plugins/axios';

export default {
	getQuestionGroups(params) {

		return apiClient.get('v1/QuestionGroup', {params});
	},

	getQuestionGroup(questionGroupId) {
		return apiClient.get(`v1/QuestionGroup/${questionGroupId}`);
	},

	createQuestionGroup(questionGroup) {
		return apiClient.post('v1/QuestionGroup', questionGroup);
	},

	updateQuestionGroup(questionGroup) {
		var questionGroupId = questionGroup.id;

		return apiClient.put(`v1/QuestionGroup/${questionGroupId}`, questionGroup);
	},

	deleteQuestionGroup(questionGroupId) {
		return apiClient.delete(`v1/QuestionGroup/${questionGroupId}`);
	}
};
